import {
	chiliPayUserApi,
	type PostUserValidationRequestV2Data,
	queryClient,
	type UserKycValidationRequestPost,
	UseUserQueryKeys
} from '@capsicum/common';
import { useMutation } from '@tanstack/react-query';

const UseValidationRequestV2QueryKey = ['create-validation-request'];

export const useCreateValidationRequest = () => {
	const { data, error, isPending, isSuccess, mutate } = useMutation<
		PostUserValidationRequestV2Data,
		Error,
		UserKycValidationRequestPost
	>({
		mutationFn: async (validationRequestData: UserKycValidationRequestPost) =>
			(await chiliPayUserApi).postUserValidationRequestV2(validationRequestData),
		mutationKey: UseValidationRequestV2QueryKey,
		onSuccess: () => queryClient.invalidateQueries({ queryKey: UseUserQueryKeys })
	});

	return {
		data,
		error,
		isLoading: isPending,
		isSuccess,
		mutate
	};
};
